module.exports = __webpack_public_path__ + "img/platinum.2f1a75ef.png";